import React, { FC } from 'react'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'

export const MobilityReportDescription: FC = () => {
  const { t } = useTranslation()

  return (
    <Text>{t('confirmation_banner.MOBILITY_REPORT_TOOL.MOBILITY_REPORT_TOOL.click_on_map')}</Text>
  )
}

MobilityReportDescription.displayName = 'MobilityReportDescription'
